import { render, staticRenderFns } from "./PaymentProcess.vue?vue&type=template&id=8c46b1e2&scoped=true&"
import script from "./PaymentProcess.vue?vue&type=script&lang=ts&"
export * from "./PaymentProcess.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentProcess.vue?vue&type=style&index=0&id=8c46b1e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c46b1e2",
  null
  
)

export default component.exports